import {
	BASKET_ADD,
	BASKET_REMOVE,
	BASKET_CLEAR,
	BASKET_START,
	BASKET_FAIL,
	BASKET_SUCCESS,
	SET_TABLES,
	SET_TABLE_VERSIONS,
	SET_START_DATE,
	SET_END_DATE,
	SET_POST_RESAMPLE,
	SET_PRE_RESAMPLE,
	START_EDITING_TABLE,
	DONE_EDITING_TABLE,
	SET_AGGREGATION_METHOD
} from '../mutations.js'

import moment from 'moment'

const state = {
	tables: [],
	versions: {},
	pending: false,
	loaded: false,
	editedTable: null,
	errorMessage: '',
	start: moment().subtract(7, 'day'),
	end: moment().add(3, 'day'),
	cart: [],
	series: [],
	performanceHeaders: [],
	postResample: {
		method: '',
		step: {amount: 1, period: 'hour'}
	},
	preResample: {
		method: '',
		step: {amount: 1, period: 'hour'}
	},
	aggregationMethod: ''
}

const mutations = {
	[BASKET_ADD](state, value) {
		if (!_.find(state.cart, value))  {
			state.cart.push(value)
		}
		state.errorMessage = ''
		state.loaded = false
		state.pending = false
		state.series = []
	},
	[BASKET_REMOVE](state, value) {
		state.loaded = false
		state.pending = false
		state.series = []
		state.errorMessage = ''
		state.cart = _.reject(state.cart, value)
	},
	[BASKET_START](state, value) {
		state.pending = true
	},
	[BASKET_CLEAR](state, value) {
		state.loaded = false
		state.pending = false
		state.series = []
		state.cart = []
    state.postResample = {method: '', step: {amount: 1, period: 'hour'}}
    state.preResample = {method: '', step: {amount: 1, period: 'hour'}}
    state.aggregationMethod = ''
	},
	[BASKET_FAIL](state, value) {
		state.loaded = false
		state.pending = false
		state.series = []
		state.errorMessage = value
	},
	[BASKET_SUCCESS](state, value) {
		state.loaded = true
		state.pending = false
		state.errorMessage = ''

		var xheaders = _.filter(Object.keys(value.headers), (header)=>{
			return _.startsWith(header, 'x-tourbillon')
		})

		state.performanceHeaders = _.map(xheaders, (header)=>{
			return `${_.replace(header, 'x-tourbillon-', '')}: ${value.headers[header]}`
		})

		value = value.data
		var index = _.map(value.aggregated.index.unix, (tick) => {
			return tick * 1000
		})
		var series = _.map(Object.keys(value.aggregated.series), (name) => {
			var points = value.aggregated.series[name]
			return {
				name: name,
				animation: false,
				type: 'area',
				data: _.zip(index, points)
			}
		})

		state.series = series

	},
	[SET_TABLES](state, value) {
		state.tables = value
	},
	[SET_TABLE_VERSIONS](state, value) {
		// In Vue 3 no need to worry about the reactivity anymore
		state.versions[value.table] = value.versions
	},
	[SET_START_DATE](state, value) {
		state.start = value
	},
	[SET_END_DATE](state, value) {
		state.end = value
	},
	[SET_POST_RESAMPLE](state, value) {
		state.postResample = value
	},
	[SET_PRE_RESAMPLE](state, value) {
		state.preResample = value
	},
	[START_EDITING_TABLE](state, value) {
		state.editedTable = value
	},
	[DONE_EDITING_TABLE](state, value) {
		state.editedTable = null
	},
	[SET_AGGREGATION_METHOD](state, value) {
		state.aggregationMethod = value
	},
}

const actions = {
	clearCart({commit}) {
		commit(BASKET_CLEAR)
	},
	configureTable({commit, state}, value) {
		commit(START_EDITING_TABLE, value)
	},
	saveTableConfiguration({commit, state}, value) {
		commit(DONE_EDITING_TABLE, value)
	},
	cancelTableConfiguration({commit, state}) {
		commit(DONE_EDITING_TABLE, null)
	},
	setPostResample({commit, state}, value){
		commit(SET_POST_RESAMPLE, value)
	},
	setPreResample({commit, state}, value){
		commit(SET_PRE_RESAMPLE, value)
	},
	setGlobalAggregationMethod({commit, state}, value){
		commit(SET_AGGREGATION_METHOD, value)
	},
	setGlobalStartDate({commit, state}, value){
		if (value != state.start){
			commit(SET_START_DATE, value)
		}
	},
	setGlobalEndDate({commit, state}, value){
		if (value != state.end){
			commit(SET_END_DATE, value)
		}
	},
	fetchTables({commit}){
		return new Promise(resolve => {
			setTimeout(()=>{
				this.$http.get('table').then(
					(response) => {
						commit(SET_TABLES, _.sortBy(response.data))
						resolve()
				})
			}, 100)
		})
	},
	loadVersion({commit}, table){
		return new Promise(resolve => {
			setTimeout(()=>{
				this.$http.get(`table/${table}/versions`).then(
					(response) => {
						var versions = _.map(_.sortBy(response.data), (version) => {
							var version = {
								version: version,
								display: version.replace('T00:00:00', ''),
								unix: moment.utc(version).unix(),
								fromNow: moment.utc(version).fromNow(),
								table: table,
								start: null,
								end: null
							}
							return version
						})

						versions = _.orderBy(versions, ['unix'], ['desc'])

						var def = {
								version: '',
								display: 'default',
								unix: null,
								fromNow: null,
								table: table,
								start: null,
								end: null
						}

						versions.splice(0, 0, def)

						commit(SET_TABLE_VERSIONS, {table: table, versions: versions})
						resolve()
				})
			}, 100)
		})
	},
	addToCart({
		commit
	}, version) {
		commit(BASKET_ADD, version)
	},
	removeFromCart({
		commit
	}, version) {
		commit(BASKET_REMOVE, version)
	},
	executeBasket({
		commit, state
	}) {
		var options = _.map(state.cart, (ts) => {
			var option = {
				tablename: ts.table,
			}
			if (ts.version) {
				option["version"] = ts.version
			}
			return option
		})

		var payload = {
			options: options
		}

		if (state.start) {
			payload.start = state.start
		}
		if (state.end) {
			payload.end = state.end
		}

		if (state.preResample.method) {
			payload.pre_resample = {
				method: state.preResample.method,
				period: state.preResample.step.period,
				amount: state.preResample.step.amount
			}
		}

		if (state.postResample.method) {
			payload.post_resample = {
				method: state.postResample.method,
				period: state.postResample.step.period,
				amount: state.postResample.step.amount
			}
		}

		if (state.aggregationMethod) {
			payload.aggregation_method = state.aggregationMethod
		}

		return new Promise(resolve => {
			setTimeout(() => {
				commit(BASKET_START)
				this.$http.post('query', payload).then(
					(response) => {
						if (response.status == 200) {
							commit(BASKET_SUCCESS, response)
						} else {
							commit(BASKET_FAIL, response.data.message)
						}
						resolve()
					}
				)
			}, 500)
		})
	}
}


export default {
	actions,
	state,
	mutations
}
